<template>
  <div id="app" :class="{'set-gray':setGrayData.is_open==1&&setGrayData.set_gray==1}">
    <router-view></router-view>
  </div>
</template>

<script>
import baseApi from "@/api/base";
import { getStorage, setStorage } from "@/common/js/localstorage";

export default {
  name: 'App',
  data() {
    return {
      setGrayData: {
        set_gray: 2,
        is_open: 2
      }
    }
  },
  created() {
    this.getPlatformDictionaryList();
    this.getSetGray();
  },
  methods: {
    // 获取平台字典列表
    getPlatformDictionaryList() {
      baseApi.getPlatformDictionaryList().then((response) => {
        if (response.data.status == 0) {
          let info = response.data.data.list ? response.data.data.list : [];
          setStorage("dictionary", info);
        } else {
          this.$message({
            type: "error",
            message: response.data.info.message
          });
        }
      });
    },
    // 获取平台网页是否置灰
    getSetGray() {
      const school = getStorage("school") || {};
      baseApi.getSetGray({
        org_id: school.org_id,
        org_type: school.org_type
      }).then((response) => {
        if (response.data.status == 0) {
          this.setGrayData = response.data.data ? response.data.data : {};
        } else {
          this.$message({
            type: "error",
            message: response.data.info.message
          });
        }
      });
    }
  }
}
</script>

<style>
html,
body {
  padding: 0;
  margin: 0;
}

#app {
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
    "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #303133;
}

.set-gray {
  -webkit-filter: grayscale(100%);
  -moz-filter: grayscale(100%);
  -ms-filter: grayscale(100%);
  -o-filter: grayscale(100%);
  filter: grayscale(100%);
}

/*滚动条整体部分,必须要设置*/
::-webkit-scrollbar {
  width: 6px;
  height: 8px;
  background-color: #fff;
}
/*滚动条的轨道*/
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px #fff;
  background-color: #fff;
}
/*滚动条的滑块按钮*/
::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background-color: #ddd;
  box-shadow: inset 0 0 5px #fff;
}
/*滚动条的上下两端的按钮*/
::-webkit-scrollbar-button {
  height: 0;
  /* background-color: #009688; */
}
</style>
